<template>
  <div>
    <data-table :service="ContractService"
                :entity="entity"
                :columns="columns"
                :go-to-details-on-row-click="false"
                :clickable="false"
                ref="table">

      <div class="d-flex align-items-center" slot="client" slot-scope="{row}">
        <base-avatar :name="row.client">
        </base-avatar>
        <div class="ml-2 font-weight-bold">{{row.client}}</div>
      </div>
      <template slot="amount" slot-scope="{row}">
        {{row.amount}}
      </template>
      <template slot="valid_till" slot-scope="{row}">
        {{$formatDate(row.valid_till, FRIENDLY_DATE_FORMAT)}}
      </template>

      <template slot="extra-buttons" slot-scope="{row}">
        <base-button @click.stop="onShow(row)" outline icon size="sm">
          <i class="fas fa-eye"></i>
        </base-button>
      </template>
    </data-table>
  </div>
</template>
<script>
  import ContractService from 'src/services/ContractService'
  import entities from 'src/config/entities'
  import { getRouteName } from 'src/config/routeTypes'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'contract-balances',
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        ContractService,
        entity: entities.CONTRACT
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client',
            label: this.$t('contract.list.labels.client'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'amount',
            label: this.$t('contract.list.labels.amount'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'valid_till',
            label: this.$t('contract.list.labels.validTill'),
            minWidth: '150px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      onShow (row) {
        this.$router.push({
          name: getRouteName('contracts', entities.CLIENT), params: {
            id: row.client_uuid
          }
        })
      }
    }
  }
</script>
<style>
</style>
